import {Typography} from '@yandex-delivery/ui'

import type {ShowErrorProps} from '../../model'
import styleClasses from './classes.module.css'

export function ShowError({errorMessage}: ShowErrorProps) {
  const defaultErrorMessage = 'Cannot load map'
  return (
    <div className={styleClasses.root}>
      <Typography color="textMinor" density="normal" level="caption1" weight="regular">
        {errorMessage ?? defaultErrorMessage}
      </Typography>
    </div>
  )
}
